webpackJsonp([11],{

/***/ "./youtube-autoplay.js":
/***/ (function(module, exports) {

// include the library
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.AboundYoutubeAutoplay = function (iframeElId) {
    if (!IntersectionObserver) return;

    window.addEventListener('load', function () {
        var manager = function () {
            var isDisabled = false;
            var isLoaded = false;
            var isInView = false;
            var lastKnownState = void 0;

            return {
                getLastKnownState: function getLastKnownState() {
                    return lastKnownState;
                },
                disable: function disable() {
                    isDisabled = true;
                },
                play: function play(player) {
                    if (isDisabled) return;
                    if (!isInView) return;
                    if (!isLoaded) return;

                    lastKnownState = YT.PlayerState.PLAYING;

                    player.playVideo();
                },
                loaded: function loaded() {
                    isLoaded = true;
                },
                pause: function pause(player) {
                    if (isDisabled) return;
                    if (!isLoaded) return;

                    lastKnownState = YT.PlayerState.PAUSED;

                    player.pauseVideo();
                },
                inView: function inView() {
                    isInView = true;
                },
                outOfView: function outOfView() {
                    isInView = false;
                }
            };
        }();

        var iframeEl = document.getElementById(iframeElId);
        if (!iframeEl) return;

        var player = new YT.Player(iframeElId, {
            events: {
                'onReady': function onReady() {
                    manager.loaded();
                    manager.play(player);
                },
                // detect if user made a change (play or pause). if they did, we no longer want to automatically play/pause the video
                'onStateChange': function onStateChange(e) {
                    var state = e.data;
                    var lastKnownState = manager.getLastKnownState();

                    if (state !== YT.PlayerState.PAUSED && state !== YT.PlayerState.PLAYING && state !== YT.PlayerState.ENDED) return;
                    if (!lastKnownState) return;

                    // will know the user made the change if the state is different from what the manager knows
                    if (state !== lastKnownState) manager.disable();
                }
            }
        });

        var threshold = 0.4;

        var observer = new IntersectionObserver(function (entries, observer) {
            if (!entries || !entries.length) return;
            var entry = entries[0];

            if (entry.intersectionRatio >= threshold) {
                manager.inView();
                manager.play(player);
            } else {
                manager.outOfView();
                manager.pause(player);
            }
        }, {
            threshold: threshold
        });

        observer.observe(iframeEl);
    });
};

/***/ })

},["./youtube-autoplay.js"]);


// WEBPACK FOOTER //
// scripts/youtube-autoplay.1a8cc3b04bbe81f80918.js